import EnvFile from "./assets/env-prod.json";

declare global {
  interface Window {
    MLBBest: {
      envVariables: any;
    };
  }
}

window.MLBBest = {
  envVariables: EnvFile
};
